
export const AREA = {
  '1': '池袋(北口・西口)',
  '2': '池袋(東口)',
}

export const CATEGORY = {
  '1':'イメクラ',
  '2':'ヘルス',
  '4':'人妻・熟女',
  '5':'オナクラ',
  '6':'ピンサロ'
}



// WEBPACK FOOTER //
// ./defines.js